/* eslint-disable class-methods-use-this */
import BaseApi from '@/api/Base/BaseApi'
import {
  InquiryDetailParams,
  InquiryListParams,
  InquiryAnswerPayload,
  InquiryListPayload,
  Inquiry
} from './type'

const ROOT = '/admin'

export default class MarketingApi extends BaseApi {
  // FIXME: API 완성된 이후에 타입 수정
  getInquiryList(params: InquiryListParams) {
    // return this.agent.get<InquiryListPayload>(`${ROOT}/inquiry/list`, { params })
    return Promise.resolve<InquiryListPayload>({
      list: [{
        _id: '1',
        updatedAt: new Date(),
        createdAt: new Date(),
        inquiryType: 1,
        title: '예제 문의',
        user: {
          _id: 'user_id',
          name: '유저 이름',
          userName: '유저 이름',
          companyName: '회사 이름',
          userId: 'user_id',
          acceptedAt: new Date(),
          activatedAt: new Date(),
          createdAt: new Date(),
          expiredAt: new Date(),
          updatedAt: new Date(),
          updatedBy: 'user_id_3',
          createdBy: 'user_id_2',
          email: 'example@ahha.ai',
          invitationCode: 'invitation',
          invitationUrl: 'invitation-url',
          type: 'ACCOUNT',
          workspaceId: 'workspace',
        },
      }],
      paging: {
        num_per_page: params.num_per_page,
        page: params.page,
        sort_dir: params.sort_dir,
        sort_key: params.sort_key,
        total_count: 0,
      },
    })
  }

  getInquiryDetail(params: InquiryDetailParams) {
    // return this.agent.get<Inquiry>(`${ROOT}/inquiry/${params.id}`)
    return Promise.resolve({
      id: '123123123',
      _id: '1',
      updatedAt: new Date(),
      createdAt: new Date(),
      inquiryType: 1,
      title: '예제 문의',
      user: {
        _id: 'user_id',
        name: '유저 이름',
        userName: '유저 이름',
        companyName: '회사 이름',
        userId: 'user_id',
        acceptedAt: new Date(),
        activatedAt: new Date(),
        createdAt: new Date(),
        expiredAt: new Date(),
        updatedAt: new Date(),
        updatedBy: 'user_id_3',
        createdBy: 'user_id_2',
        email: 'example@ahha.ai',
        invitationCode: 'invitation',
        invitationUrl: 'invitation-url',
        type: 'ACCOUNT',
        workspaceId: 'workspace',
      },
      messages: [{ time: new Date(), message: '123123123' }],
    })
  }

  sendInquiryAnswer(payload: InquiryAnswerPayload) {
    // return this.agent.post(`${ROOT}/inquiry/${payload.answeredInquiryId}`, payload)
    return Promise.resolve('답변 전송')
  }

  deleteInquiryAnswer(params: InquiryDetailParams) {
    // return this.agent.delete(`${ROOT}/inquiry/${params.id}`)
    return Promise.resolve('답변 삭제')
  }
}
